/**
 * Konwersja między grupami reguł filtrów (IFilterRow[][]) a płaską listą (IWiseTableAdvancedFilter[]).
 * Używane w useWiseTableAdvancedFilters i przy zapisie do API.
 */

import type { IWiseTableAdvancedFilter, IFilterRow } from 'components/wise/types';

/** Buduje płaską listę filtrów z grup (do zapisu w Redux / API). */
export function buildFiltersFromGroups(groups: IFilterRow[][]): IWiseTableAdvancedFilter[] {
  const result: IWiseTableAdvancedFilter[] = [];
  groups.forEach((group, groupIdx) => {
    const comparisonRows = group.filter(
      (row) =>
        row.columnFieldSymbol != null &&
        row.operator != null &&
        ['eq', 'gt', 'lt', 'contains'].includes(row.operator) &&
        row.value.trim() !== ''
    );
    comparisonRows.forEach((row, i) => {
      result.push({
        columnFieldSymbol: row.columnFieldSymbol!,
        operator: row.operator!,
        value: row.value.trim()
      });
      const connector = row.connectorAfter ?? 'and';
      if (i < comparisonRows.length - 1) {
        result.push({ columnFieldSymbol: '', operator: connector, value: '' });
      }
    });
    if (groupIdx < groups.length - 1 && comparisonRows.length > 0) {
      result.push({ columnFieldSymbol: '', operator: 'and', value: '' });
    }
  });
  return result;
}

/** Buduje grupy (reguły) z płaskiej listy filtrów – do inicjalizacji stanu z Redux. */
export function filtersToGroups(filters: IWiseTableAdvancedFilter[]): IFilterRow[][] {
  const isComparison = (f: IWiseTableAdvancedFilter) =>
    f.columnFieldSymbol && ['eq', 'gt', 'lt', 'contains'].includes(f.operator);
  const groups: IFilterRow[][] = [];
  let currentGroup: IFilterRow[] = [];
  let prevColumn: string | null = null;
  for (let i = 0; i < filters.length; i++) {
    const f = filters[i];
    if (isComparison(f)) {
      const next = filters[i + 1];
      const connectorAfter: 'and' | 'or' =
        next && !next.columnFieldSymbol && (next.operator === 'or' || next.operator === 'and')
          ? next.operator
          : 'and';
      const row: IFilterRow = {
        columnFieldSymbol: f.columnFieldSymbol,
        operator: f.operator,
        value: f.value,
        connectorAfter
      };
      if (
        currentGroup.length > 0 &&
        prevColumn != null &&
        f.columnFieldSymbol !== prevColumn
      ) {
        groups.push(currentGroup);
        currentGroup = [];
      }
      currentGroup.push(row);
      prevColumn = f.columnFieldSymbol;
      if (next && !next.columnFieldSymbol) i++;
    }
  }
  if (currentGroup.length > 0) groups.push(currentGroup);
  return groups;
}
